import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no 6.5-hour drive to Houston needed",
      "Ideal for Tinker AFB military families on PCS orders",
      "Perfect for downtown energy executives on overseas deals",
      "Great for OU Health physicians attending international conferences",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Oklahoma County post offices",
      "Good for planned international trips from OKC",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Oklahoma City area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Houston — ~450 miles via I-35/I-45",
      "Oklahoma has ZERO passport agencies — no in-state option exists",
      "NPIC appointment required before driving to Houston",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect a full-day commitment and overnight if weather hits",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function OKCProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Oklahoma City"
      headingExtra="OK"
      introText="Oklahoma City and Central Oklahoma travelers — Tinker AFB military families on PCS orders, downtown energy executives on international deals, OU Health physicians attending global conferences, and Will Rogers World Airport (OKC) flyers — have several options for getting a passport fast. Here is how they compare, and why most Central Oklahoma residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 6.5-hour drive to Houston."
      options={options}
      emergencyDescription="Oklahoma has ZERO passport agencies — the state's 4M+ residents have no in-state emergency option. The closest agency is Houston, roughly 450 miles south via I-35 and I-45, a 6.5-hour drive each way. Tinker Air Force Base is the largest single-site employer in Oklahoma with 26,000+ military and civilian personnel — when service members receive short-notice PCS orders to overseas bases, the round trip to Houston consumes an entire day. Spring tornado season (March–June) has produced EF-5 tornadoes that crossed I-35 in the OKC metro. When severe weather shuts down I-35, Oklahoma City is severed from Houston's agency entirely."
      disclaimerText="*Processing speed depends on eligibility and documentation. Oklahoma has ZERO passport agencies — the closest is Houston, roughly 450 miles and 6.5+ hours away via I-35/I-45. Not all applicants qualify for Regional Agency Processing."
    />
  );
}